import React, { Component } from 'react'
import { Group, InfoDetails, Label, Tag, Title, Value } from '../styles/dialpadstyle';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import {
  Button
} from 'modules/theme';
import {
  AddNewCallDiv,
  AvatarBreakDiv,
  BreakBar
} from '../styles/dialpadstyle'
import CommonManager from '../../../../../helpers/common';
const commonManager = new CommonManager();
export class CallInfoTheme extends Component {
  constructor(props) {
    super(props)
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.renderList = this.renderList.bind(this);
    this.previewTimer = props.previewTimer;
    this.previewStartTimer = props.previewStartTimer;
    this.timer = "";
    this.state = {
      time: props.previewTimer
    }
    if (props.isPreview) {
      this.startTimer();
    }
  }
  stopTimer() {
    clearInterval(this.timer)
  }
  startTimer() {
    const { doneFn, userState } = this.props;
    let state = userState.State || '';
    let _this = this;
    _this.stopTimer();
    this.timer = setInterval(() => {
      let current = parseInt(new Date() / 1000)
      let diff = current - _this.previewStartTimer
      if (diff < _this.previewTimer) {
        _this.setState({ time: (_this.previewTimer - diff) })
      } else {
        _this.stopTimer();
        if (state == "preview") {
          doneFn();
        }
      }
    }, 1000)
  }
  renderList(info) {
    const { customerNumber, customerName, teamList, team, previewTeam, callTeam, userState } = this.props
    let state = userState.State || '';
    let numberMask = {};
    let phone_number = customerNumber ? customerNumber : ''
    try {
      teamList.map(e => {
        numberMask[e._id] = e.numberMasking || false;
      });
    } catch (error) {
    }
    if (state === "preview") {
      phone_number = previewTeam && previewTeam.teamId && numberMask[`${previewTeam.teamId}`] === true ? commonManager.maskText(phone_number) : phone_number
    }
    else {
      phone_number = callTeam && callTeam._id && numberMask[`${callTeam._id}`] === true ? commonManager.maskText(phone_number) : phone_number
    }
    var list = [];

    if (info && typeof info === 'object' && (!Object.keys(info).includes('Name') && !Object.keys(info).includes('name'))) {
      list.push(
        <Group>
          <Label>
            Name
          </Label>
          <Value style={{ marginRight: '5px' }}>
            {customerName || "No Name"}
          </Value>
        </Group>
      );
    }
    list.push(
      <Group>
        <Label>
          Number
        </Label>
        <Value style={{ marginRight: '5px' }}>
          {phone_number || "-"}
        </Value>
      </Group>
    );
    if (typeof info == "object") {
      for (const key in info) {
        if (Object.hasOwnProperty.call(info, key)) {
          list.push(
            <Group style={{textTransform: "capitalize"}}>
              <Label>
                {key}
              </Label>
              <Value style={{ marginRight: '5px', textTransform: "capitalize" }}>
                {typeof info[key] == "string" && info[key].trim() !== "" ? info[key] : "-"}
              </Value>
            </Group>
          );
        }
      }
    }
    if (list && list.length) {
      return list;
    } else {
      return (
        <AddNewCallDiv>
          <BreakBar>
            <AvatarBreakDiv>
              <img src="/images/icons/information.png" />
            </AvatarBreakDiv>
            <h4>{"No Detail !!!"}</h4>
          </BreakBar>
        </AddNewCallDiv>
      )
    }
  }
  render() {
    const { title, info, isPreview, isCallback, doneFn, skipFn } = this.props;
    const { time } = this.state;
    return (
      <span style={{ display: 'block', width: '100%' }}>
        <Title>
          {title}
        </Title>
        <InfoDetails>
          {this.renderList(info)}

        </InfoDetails>
        {(isPreview || isCallback) && <Button
          btnStyle="filter"
          block
          className="lightbutton-btn"
          onClick={() => {
            skipFn();
          }}
          size="medium"
          style={{ marginBottom: '10px', fontWeight: '600', "textAlign": "center", display: "block" }}
        >
          {isCallback ? `Back` : `Skip`}
        </Button>}

        {(isPreview || isCallback) && <Button
          btnStyle="default"
          className="lightbutton-btn"
          block
          onClick={() => {
            this.stopTimer()
            doneFn();
          }}
          size="medium"
          style={{ fontWeight: '600', "textAlign": "center", display: "block" }}
        >
          {isCallback ? `Dial` : `Dial ${time}`}
        </Button>}

      </span>
    )
  }
  componentWillUnmount() {
    this.stopTimer()
  }
}

const stateToProps = state => ({
  userState: globalStateSelector.getState(state),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  customerName: globalStateSelector.getCallCustomerName(state),
  team: globalStateSelector.getSelectedTeam(state),
  teamList: globalStateSelector.getTeamList(state),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  previewTeam: globalStateSelector.getDynamic(state, { key: 'previewTeam' }),
  userState: globalStateSelector.getState(state),
});

const dispatchToProps = dispatch => ({
});
export default connect(stateToProps, dispatchToProps)(CallInfoTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallInfoTheme.js